import React, { useState } from 'react';
import { Button, FormControl, Grid, InputLabel, Stack } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import SnackbarNotify from '../../utils/snackbar/SnackbarNotify';
import RentalService from '../../services/rental.service';
import {
    formatLocalDateToUtcTime,
    parseUtcTimeToLocalDate
} from '../../utils/helpers/date-time.helper';

const RentalCheckTimesForm = ({ initialValues, selectedOrg }) => {
    const [loading, setLoading] = useState(false);

    const defaults = {
        check_in_time: selectedOrg?.check_in_time
            ? parseUtcTimeToLocalDate(selectedOrg.check_in_time)
            : null,

        check_out_time: selectedOrg?.check_out_time
            ? parseUtcTimeToLocalDate(selectedOrg.check_out_time)
            : null
    };

    const validationSchema = Yup.object().shape({
        check_in_time: Yup.date().required('Check-in time required'),
        check_out_time: Yup.date().required('Check-out time required')
    });

    const handleSubmit = async values => {
        const formattedData = {
            check_in_time: formatLocalDateToUtcTime(values.check_in_time),
            check_out_time: formatLocalDateToUtcTime(values.check_out_time)
        };
        try {
            setLoading(true);
            await RentalService.updateOrgRentalCheckTimes(
                selectedOrg.org_id,
                formattedData
            );
            SnackbarNotify.success('Rental check times updated successfully!');
        } catch (e) {
            SnackbarNotify.error('Failed: ' + (e.message || 'Something went wrong'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Formik
            initialValues={defaults}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ values, setFieldValue, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <Stack spacing={0.5}>
                                    <InputLabel>Check-in Time</InputLabel>
                                    <FormControl fullWidth>
                                        <TimePicker
                                            value={values.check_in_time}
                                            onChange={v =>
                                                setFieldValue('check_in_time', v)
                                            }
                                        />
                                    </FormControl>
                                </Stack>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Stack spacing={0.5}>
                                    <InputLabel>Check-out Time</InputLabel>
                                    <FormControl fullWidth>
                                        <TimePicker
                                            value={values.check_out_time}
                                            onChange={v =>
                                                setFieldValue('check_out_time', v)
                                            }
                                        />
                                    </FormControl>
                                </Stack>
                            </Grid>

                            <Grid item xs={12}>
                                <Stack direction="row" justifyContent="flex-end">
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        disabled={loading}
                                    >
                                        Save
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </LocalizationProvider>
                </form>
            )}
        </Formik>
    );
};

export default RentalCheckTimesForm;
